function mapPlaceBox(place) {
    switch (place) {
      case "B":
        return "Rez de chaussée";
      case "H":
        return "Etage";
      case "":
        return "Conteneurs";
      default:
        return place;
    }
  }
export default mapPlaceBox;